import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { useCartContext } from 'state/cart';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

import { Container, Header, LineItem, TextDetails, Title, TitleContainer } from './styled';

const PriceMismatchInternalOnly = () => {
  const enablePriceMismatch = useFlag(LaunchDarklyFlag.ENABLE_PRICE_MISMATCH_INTERNAL_ONLY);
  const { formatMessage } = useIntl();

  const {
    requestedAmountCents,
    serverOrder,
    priceOrderFailure,
    isOrderPricingRetryInProgress,
  } = useCartContext();

  const subTotalCents = serverOrder?.cart.subTotalCents;
  const isPriceMismatch = subTotalCents && subTotalCents !== requestedAmountCents;
  const isPriceFailureFinal = priceOrderFailure && !isOrderPricingRetryInProgress;

  if (!enablePriceMismatch || (!isPriceMismatch && !isPriceFailureFinal)) {
    return null;
  }

  return (
    <Container>
      <Header>{formatMessage({ id: 'forInternalUseOnly' })}</Header>
      <LineItem>
        <TextDetails>RBI Order ID</TextDetails>
        <TextDetails>{serverOrder?.rbiOrderId}</TextDetails>
      </LineItem>
      <LineItem>
        <TextDetails>Status</TextDetails>
        <TextDetails>{serverOrder?.status}</TextDetails>
      </LineItem>
      {serverOrder?.delivery?.status && (
        <LineItem>
          <TextDetails>Delivery Status</TextDetails>
          <TextDetails>{serverOrder.delivery.status}</TextDetails>
        </LineItem>
      )}
      {isPriceMismatch && (
        <>
          <TitleContainer>
            <Icon variant="warning" color={primitive.$white} aria-hidden size="4" />
            <Title>{formatMessage({ id: 'priceMismatchDetected' })}</Title>
          </TitleContainer>
          <LineItem>
            <TextDetails>{formatMessage({ id: 'requestedAmount' })}</TextDetails>
            <Currency textProps={{ color: primitive.$white }} amount={requestedAmountCents} />
          </LineItem>
          <LineItem>
            <TextDetails>{formatMessage({ id: 'subtotal' })}</TextDetails>
            <Currency textProps={{ color: primitive.$white }} amount={subTotalCents} />
          </LineItem>
        </>
      )}
      {priceOrderFailure && (
        <>
          <TitleContainer>
            <Icon variant="warning" color={primitive.$white} aria-hidden size="4" />
            <Title>Pricing Error</Title>
          </TitleContainer>
          <LineItem>
            <TextDetails>Error Type</TextDetails>
            {serverOrder?.orderErrors?.orderInjectionErrors?.isStoreAvailabilityError && (
              <TextDetails>Store Availability Error</TextDetails>
            )}
            {serverOrder?.orderErrors?.orderInjectionErrors?.isTimeoutError && (
              <TextDetails>Timeout Error</TextDetails>
            )}
            {serverOrder?.orderErrors?.orderInjectionErrors?.isMenuError && (
              <TextDetails>Menu Error</TextDetails>
            )}
            {serverOrder?.orderErrors?.orderInjectionErrors?.isConfigurationError && (
              <TextDetails>Configuration Error</TextDetails>
            )}
            {serverOrder?.orderErrors?.orderInjectionErrors?.isUnknownError && (
              <TextDetails>Unknown Error</TextDetails>
            )}
          </LineItem>
        </>
      )}
    </Container>
  );
};

export default PriceMismatchInternalOnly;
